import * as React from 'react';

import {GoogleLogoIcon} from 'shells/logos/google-g';
import {Office365LogoIcon} from 'shells/logos/office-365';

import type {CalendarSync} from 'nutshell-graphql-types';
import {SelectWithIcon} from 'shells/select-picker/../select-picker/select-with-icon/select-with-icon';

import {useSelectCalendarSyncCalendar} from '../../setup/calendar/graphql/hooks/use-select-calendar-sync-calendar';

type Props = {
    status: CalendarSync;
    maxMenuHeight?: number;
};

export function SelectCalendarDropdown(props: Props) {
    const {calendars} = props.status;

    const {selectCalendarSyncCalendar} = useSelectCalendarSyncCalendar();
    const calendarOptions = calendars.map((cal) => {
        return {
            value: cal.id,
            label: cal.name,
            icon: props.status.externalService === 'OFFICE365' ? Office365LogoIcon : GoogleLogoIcon,
            isDisabled: cal.syncType === 'CONFLICT',
            title:
                cal.syncType === 'CONFLICT'
                    ? 'This calendar is already added. To sync this calendar, disconnect it as an extra calendar.'
                    : null,
        };
    });

    const selectedCalendar = calendars.find((cal) => cal.isSelected);
    const selectedCalendarName = selectedCalendar ? selectedCalendar.name : null;
    const selectedCalendarOption = calendarOptions.find(
        (option) => option.label === selectedCalendarName
    );

    const selectRef = React.createRef();

    return (
        <div className='mb-8'>
            <SelectWithIcon
                selectRef={selectRef}
                placeholder='Select a calendar'
                options={calendarOptions}
                value={selectedCalendarOption ? selectedCalendarOption.value : null}
                // @ts-expect-error
                onChange={(newCalendarId) => {
                    selectCalendarSyncCalendar(newCalendarId);
                }}
                maxMenuHeight={props.maxMenuHeight}
            />
        </div>
    );
}
